export default __webpack_public_path__ + "static/media/23.4b9bb49b.jpg";